import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IMetricDataList } from '~src/metrics/serverApi/types/IMetricDataList';

export interface GetWorkbookUsageMetricsParams {
  workbookId: string;
}

export interface GetWorkbookUsageMetricsResult extends IResult, IMetricDataList {}

export class GetWorkbookUsageMetricsRequest extends Request<GetWorkbookUsageMetricsParams, GetWorkbookUsageMetricsResult> {
  constructor(params: GetWorkbookUsageMetricsParams) {
    super('getUsageMetrics', params);
  }
}
